export default {
  '***': {
    '***': {
      headerHeight: 80,
      rowTitleHeight: 35,
      padding: 1,
      aspectRatio: 0.7727,
      externalHeaderHeight: 0,
      minContainerHeight: 1000,
      horizontalMargin: 10,
      verticalMargin: 10,
      rows: [
        {
          height: 0.33,
          title: 'IN-MARKET PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricDonut',
                  data: {
                    dataFormat: "perc",
                    metric: 1,
                    metricScale: 200
                  }
                }
              ],
              width: 0.3,
              key: null
            },
            {
              content: [                
                {
                  component: 'MetricDonut',
                  data: {
                    dataFormat: "perc",
                    metric: 3,
                    metricScale: 200
                  }
                }
              ],
              width: 0.3,
              key: null
            },
            {
              content: [{
                component: 'MetricVerticalArray',
                data: {
                  label: 'Persuasion',
                  metrics: [
                    {
                      metric: 122,
                      maxValue: 0.8,
                      format: '%,1'
                    },
                    {
                      metric: 121,
                      maxValue: 0.8,
                      format: '%,1'
                    }
                  ]
                }
              }],
              width: 0.35,
              key: null
            },            

          ]
        },
        {
          height: 0.67,
          title: 'CREATIVE PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'BRAND LINKAGE & BRANDING DIAGNOSTICS',
                    metrics: [
                      { metric: 2, isHeaderMetric: true },
                      { metric: 4, isHeaderMetric: true },
                      { metric: 5, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              legend: {
                xOffset: 10,
                yOffset: -20
              },
              width: 0.3,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricChart',
                  data: {
                    title: 'AD IMPRESSIONS',
                    dataFormat: "perc",
                    mainMetric: {
                      // type: 'horizontal',
                      // scale: {
                      //   start: 85,
                      //   end: 155
                      // },
                      // metric: 200,
                      // label: 'Creative Summary Score'
                    },
                    subMetrics: [
                      { metric: 7, label: 'Is informative' },
                      { metric: 8, label: 'Tells me something new about the brand' },
                      { metric: 9, label: 'Makes me feel closer to the brand' },
                      { metric: 10, label: 'Is credible coming from this brand' },
                      { metric: 11, label: 'Speaks directly to me' },
                      { metric: 12, label: 'Portrays a brand I want to be associated with' },
                      { metric: 13, label: 'Is relevant to me ' },
                      { metric: 14, label: 'Is humorous' },
                      { metric: 15, label: 'Is worth talking about' },
                      { metric: 16, label: 'Is a good fit with this brand' },
                      { metric: 17, label: 'Is memorable' },

                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricOpenend',
                  data: {
                    label: 'In Their Own Words',
                    topBox: {
                      likes: {
                        metric: 6,
                        noStatColor: '#BFBFBF'
                      },
                      dislikes: {
                        metric: 28,
                        noStatColor: '#AFABAB'
                      }
                    },
                    messageField: 'message',
                    wordcloudConfig: {
                      sentiments: [
                        { color: '#FF872F', description: 'Very Negative' },
                        { color: '#FFC397', description: 'Negative' },
                        { color: '#DAD9D6', description: 'Neutral' },
                        { color: '#C4E1AF', description: 'Positive' },
                        { color: '#89C35F', description: 'Very Positive' }
                      ],
                      scoreRange: [0, 7],
                      font: 'Arial, Helvetica, sans-serif',
                      showCounts: false,
                      padding: 5,
                      rotation: 0,
                      wordCountCutoff: 2,
                      wordLengthCutoff: 3,
                      numDisplayed: 100
                    }
                  }
                }
              ],
              width: 0.35,
              key: null
            }
          ]
        }
      ],
      legend: {
        metadataFields: [
          {
            value: 'last_month_tested',
            label: 'Last Tested'
          }
        ],
        includeSelections: true,
        includeStatTesting: true,
        includeFilters: {
          label: 'Target',
          default: 'Total Consumers'
        }
      }
    }


  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/HEB/config/components/quickview/index.js